import $i18n from '@/locales/i18n';
import Icon from './logo';
import { getArraySetterSnippet } from '@/common/manager/setter-snippet';
const CnLayoutHeaderPrototype = {
    title: $i18n.get({ id: 'PageHeader', dm: '页头' }),
    componentName: 'CnLayoutHeader',
    icon: Icon,
    docUrl: '',
    isContainer: true,
    configure: [
        {
            name: 'isCnLayoutHeader',
            title: 'CnLayoutHeader',
            initialValue: true,
            display: 'none',
        },
        {
            name: '_context',
            title: $i18n.get({ id: 'Context', dm: '上下文' }),
            initialValue: {
                type: 'JSExpression',
                value: 'this',
            },
            display: 'none',
        },
        {
            name: 'title',
            title: $i18n.get({ id: 'Title', dm: '标题' }),
            display: 'inline',
            setter: 'CnI18nSetter',
            supportVariable: true,
        },
        {
            name: 'desc',
            title: $i18n.get({ id: 'TERM.Description', dm: '描述' }),
            display: 'inline',
            setter: 'CnI18nSetter',
            supportVariable: true,
        },
        {
            name: 'avatar.src',
            title: $i18n.get({ id: 'Avatar', dm: '头像' }),
            display: 'inline',
            setter: 'StringSetter',
            supportVariable: true,
        },
        {
            name: 'label',
            title: $i18n.get({ id: 'TERM.Label', dm: '标签' }),
            display: 'inline',
            supportVariable: true,
            setter: getArraySetterSnippet({
                configure: [
                    {
                        name: 'name',
                        title: $i18n.get({ id: 'Name', dm: '名称' }),
                        setter: 'CnI18nSetter',
                        isRequired: true,
                    },
                ],
            }),
        },
    ],
};
// 原型配置请参考：https://lark.alipay.com/vision/docs/prototype
export { CnLayoutHeaderPrototype };
